export function toTitleCase(str) {
  const locale = 'tr-TR';
  const splitStr = str.toLocaleLowerCase(locale).split(' ');
  for (let i = 0; i < splitStr.length; i += 1) {
    splitStr[i] = splitStr[i].charAt(0).toLocaleUpperCase(locale) + splitStr[i].substring(1);
  }
  return splitStr.join(' ');
}
